$.sortable = function () {
    $(".sortable_items").sortable({
        axis: "x",
    });
};
